import React, { useContext } from 'react';
import { useLocation } from 'react-router';
import GradientLink from '../GradientLink/GradientLink';
import ThemeToggle from '../ThemeToggle/ThemeToggle';
import { ThemeContext } from '../ThemeContext/ThemeContext';
import ScrollProgress from '../ScrollProgress/ScrollProgress';
import { Styled } from './Header.styles';
import Logo from '../Intro/Logo';

const Header = () => {
	const { colorMode } = useContext(ThemeContext);
	const location = useLocation();
	return (
		<Styled.Header colorMode={colorMode}>
			<Styled.HeaderContent>
				<Styled.HeaderLogo>
					<GradientLink bold
						url="/"
						color={colorMode && colorMode === 'dark' ? '#fff' : '#121619'}>
						<Logo
							style={{
								width: '100%',
								height: '1rem',
							}}
						/>
					</GradientLink>
				</Styled.HeaderLogo>
				<Styled.HeaderActions>
					<ThemeToggle />
					{/* <Styled.HeaderToggleNavButton onClick={toggleNavOpen}
						type="button">
						<Styled.HeaderNavMenuLine colorMode={colorMode} />
						<Styled.HeaderNavMenuLine colorMode={colorMode} />
					</Styled.HeaderToggleNavButton> */}
				</Styled.HeaderActions>
			</Styled.HeaderContent>
			{location && location.pathname !== '/' && <ScrollProgress />}
		</Styled.Header>
	);
};

// Header.propTypes = {
// 	toggleNavOpen: PropTypes.func.isRequired,
// };

export default Header;
